import { render, staticRenderFns } from "./ItemRecommendations.vue?vue&type=template&id=06fb8074&"
import script from "./ItemRecommendations.vue?vue&type=script&lang=js&"
export * from "./ItemRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports